// Plain-language notices about a delivery's state (Backlog #179/#212/#133/#215,
// 2026-10-23). The backend decides WHAT is wrong (app/utils/delivery_issues.py,
// merged into each delivery's row_counts as `issue`, and the accept result's
// qa_failed/qa_missing); this file only decides how to word and when to show it.

// What an Accept action tells the PM. `data` is POST /supplier-deliveries/{id}/accept's body.
// A QA failure used to leave leads in Under Review with no results, which looks the same
// as QA never running (it hid the 2026-10-06 Indeed outage).
export function describeAcceptResult(data) {
  const d = data || {};
  const failed = d.qa_failed || 0;
  const missing = d.qa_missing || 0;
  const moved = d.updated || 0;
  if (failed === 0 && missing === 0) {
    return { warn: false, text: moved ? `${moved} lead${moved !== 1 ? 's' : ''} moved to Under Review, QA ran on ${d.qa_run || 0}.` : 'Nothing was waiting to be accepted.' };
  }
  const n = failed || missing;
  let text = `⚠ QA did not complete for ${n} of ${moved} lead${moved !== 1 ? 's' : ''}. They are in Under Review with no QA results, which looks the same as QA never having run. Re-run QA from Lead QA Review before relying on them.`;
  const sample = (d.qa_error_samples || []).filter(Boolean)[0];
  if (sample) text += ` First error: ${sample}`;
  return { warn: true, text };
}

// Should a delivery's `issue` banner show here? An "all leads rejected" notice only
// matters while the delivery is still waiting to be accepted; once it has been
// accepted (or the screen doesn't know the status) it would be stale noise.
export function issueVisible(issue, status) {
  if (!issue) return false;
  if (issue.code === 'all_rejected') return status === 'Pending';
  return true;
}

const LEVEL_STYLE = {
  error:   { background: '#fdedec', color: '#c0392b', border: '#f5b7b1' },
  warning: { background: '#fef9e7', color: '#b7770d', border: '#f9e79f' },
  info:    { background: '#eaf0fb', color: '#1a6da8', border: '#aed6f1' },
};
export function issueStyle(issue) {
  return LEVEL_STYLE[issue?.level] || LEVEL_STYLE.warning;
}
